import React, { useRef, useState, useImperativeHandle, useEffect } from 'react';
import clsx from 'clsx';
import { UIGameCard } from '../UIGameCard/index.ts';
import styles from './UIGameResourceCardsTooltipContent.module.scss';
export function UIGameResourceCardsTooltipContent({ cardsToBuild, cardInventory, ref }) {
    const [flickerAnimation, setFlickerAnimation] = useState(false);
    const animationTimeoutRef = useRef(null);
    const triggerFlickerAnimation = ()=>{
        setFlickerAnimation(true);
        if (animationTimeoutRef.current) {
            clearTimeout(animationTimeoutRef.current);
        }
        animationTimeoutRef.current = setTimeout(()=>{
            setFlickerAnimation(false);
            animationTimeoutRef.current = null;
        }, 1000);
    };
    useEffect(()=>()=>{
            if (animationTimeoutRef.current) {
                clearTimeout(animationTimeoutRef.current);
            }
        }, []);
    useImperativeHandle(ref, ()=>({
            triggerFlickerAnimation: triggerFlickerAnimation
        }));
    const remainingInventory = {};
    cardInventory.forEach((card)=>{
        var _remainingInventory_card;
        remainingInventory[card] = ((_remainingInventory_card = remainingInventory[card]) !== null && _remainingInventory_card !== void 0 ? _remainingInventory_card : 0) + 1;
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.container
    }, cardsToBuild.map((card, index)=>{
        let isMissingCard = false;
        if (remainingInventory[card] != null && remainingInventory[card] > 0) {
            remainingInventory[card] -= 1;
        } else {
            isMissingCard = true;
        }
        return /*#__PURE__*/ React.createElement(UIGameCard, {
            cardEnum: card,
            size: "sm",
            className: clsx({
                [styles.brightnessFlickerAnimation]: flickerAnimation && isMissingCard
            }),
            isDisabled: isMissingCard,
            key: index
        });
    }));
}
